import { X } from "lucide-react";
import { passage } from "../content/passage";
import { useModalFocus } from "../hooks/useModalFocus";
import type { ChapterId, EvidenceId } from "../types";

interface PassageDrawerProps {
  open: boolean;
  chapterId: ChapterId;
  focusIds?: string[];
  onClose: () => void;
  onEvidenceViewed: (evidenceId: EvidenceId) => void;
}

// 课文抽屉按章节显示原文，并高亮当前任务证据段落。
export function PassageDrawer({ open, chapterId, focusIds = [], onClose, onEvidenceViewed }: PassageDrawerProps) {
  const paragraphs = passage.filter((paragraph) => paragraph.section === chapterId);
  const { dialogRef, initialFocusRef, requestClose } = useModalFocus(open, onClose);

  if (!open) return null;

  return (
    <div className="drawer-backdrop" role="presentation" onMouseDown={requestClose}>
      <aside ref={dialogRef} className="passage-drawer" role="dialog" aria-modal="true" aria-label="课文原文" tabIndex={-1} onMouseDown={(event) => event.stopPropagation()}>
        <div className="passage-drawer__header">
          <div>
            <span className="section-kicker">课文证据</span>
            <h2>《大自然的语言》</h2>
          </div>
          <button ref={initialFocusRef} className="icon-button" type="button" onClick={requestClose} title="关闭课文" aria-label="关闭课文">
            <X size={20} />
          </button>
        </div>
        <p className="passage-drawer__source">原文出自竺可桢、宛敏渭《大自然的语言》</p>
        <div className="passage-drawer__body">
          {paragraphs.map((paragraph) => (
            <button
              className={`passage-paragraph ${focusIds.includes(paragraph.id) ? "is-focused" : ""}`}
              type="button"
              key={paragraph.id}
              onClick={() => onEvidenceViewed(paragraph.id)}
            >
              <span>{paragraph.id}</span>
              <p>{paragraph.text}</p>
            </button>
          ))}
        </div>
      </aside>
    </div>
  );
}
